import { render, staticRenderFns } from "./CopMaterialList.vue?vue&type=template&id=a3670b06&scoped=true&"
import script from "./CopMaterialList.vue?vue&type=script&lang=js&"
export * from "./CopMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3670b06",
  null
  
)

export default component.exports